export default __webpack_public_path__ + "static/media/amazonas.f683e909.png";